/* @patrol-fixer:pop-up */
(() => {
  // src/marker-fixes/watchMarkedElements.ts
  function watchMarkedElements(selector, managedAttribute, attach) {
    const attachOnce = (element) => {
      if (element instanceof HTMLElement && !element.hasAttribute(managedAttribute)) {
        element.setAttribute(managedAttribute, "");
        attach(element);
      }
    };
    const attachWithin = (root) => {
      if (root.matches(selector)) {
        attachOnce(root);
      }
      for (const element of root.querySelectorAll(selector)) {
        attachOnce(element);
      }
    };
    attachWithin(document.documentElement);
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node instanceof Element) {
            attachWithin(node);
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // src/marker-fixes/popupFocusManagementFix.ts
  const FOCUSABLE_SELECTOR =
    'a[href], area[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, [tabindex]:not([tabindex="-1"]), [contenteditable]';
  const ESCAPE_CLOSE_WAIT_MS = 150;
  function isPopupVisible(popup) {
    if (popup.hasAttribute("hidden")) {
      return false;
    }
    if (popup.getAttribute("aria-hidden") === "true") {
      return false;
    }
    if (popup instanceof HTMLDialogElement && !popup.open) {
      return false;
    }
    const style = window.getComputedStyle(popup);
    return style.display !== "none" && style.visibility !== "hidden" && parseFloat(style.opacity) !== 0;
  }
  function getVisibleFocusableElements(popup) {
    const focusables = popup.querySelectorAll(FOCUSABLE_SELECTOR);
    return Array.from(focusables).filter((element) => element.getClientRects().length > 0);
  }
  function findVisibleCloseControl(popup) {
    const controls = popup.querySelectorAll('[data-close], button[class*="close" i], [aria-label*="close" i]');
    for (const control of controls) {
      if (control.getClientRects().length > 0) {
        return control;
      }
    }
    return null;
  }
  function attachPopupFocusManagement(popup) {
    let isOpen = isPopupVisible(popup);
    let triggerElement = null;
    const handleKeydown = (event) => {
      if (!popup.isConnected) {
        handleClose();
        return;
      }
      if (event.key === "Tab") {
        const focusables = getVisibleFocusableElements(popup);
        if (focusables.length === 0) {
          return;
        }
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        const active = document.activeElement;
        if (!popup.contains(active)) {
          event.preventDefault();
          first.focus();
        } else if (event.shiftKey && active === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && active === last) {
          event.preventDefault();
          first.focus();
        }
      } else if (event.key === "Escape") {
        window.setTimeout(() => {
          let _a;
          if (!popup.isConnected || !isPopupVisible(popup)) {
            return;
          }
          if (popup instanceof HTMLDialogElement) {
            popup.close();
            return;
          }
          (_a = findVisibleCloseControl(popup)) == null ? void 0 : _a.click();
        }, ESCAPE_CLOSE_WAIT_MS);
      }
    };
    const handleOpen = () => {
      const active = document.activeElement;
      triggerElement = active instanceof HTMLElement && !popup.contains(active) ? active : null;
      if (!popup.contains(active)) {
        const focusables = getVisibleFocusableElements(popup);
        if (focusables.length > 0) {
          focusables[0].focus();
        } else {
          if (!popup.hasAttribute("tabindex")) {
            popup.setAttribute("tabindex", "-1");
          }
          popup.focus();
        }
      }
      document.addEventListener("keydown", handleKeydown);
    };
    const handleClose = () => {
      document.removeEventListener("keydown", handleKeydown);
      if (triggerElement == null ? void 0 : triggerElement.isConnected) {
        triggerElement.focus();
      }
      triggerElement = null;
    };
    const observer = new MutationObserver(() => {
      const isVisible = isPopupVisible(popup);
      if (isVisible === isOpen) {
        return;
      }
      isOpen = isVisible;
      if (isVisible) {
        handleOpen();
      } else {
        handleClose();
      }
    });
    observer.observe(popup, {
      attributes: true,
      attributeFilter: ["class", "style", "aria-hidden", "open", "hidden"],
    });
  }
  const popupFocusManagementFix = {
    id: "pop-up",
    start: () => watchMarkedElements("[data-patrol-pop-up]", "data-patrol-pop-up-managed", attachPopupFocusManagement),
  };

  // <stdin>
  popupFocusManagementFix.start();
})();
/* @end-patrol-fixer:pop-up */
/* @patrol-fixer:stamped-rating-bars */
(() => {
  // src/marker-fixes/watchMarkedElements.ts
  function watchMarkedElements(selector, managedAttribute, attach) {
    const attachOnce = (element) => {
      if (element instanceof HTMLElement && !element.hasAttribute(managedAttribute)) {
        element.setAttribute(managedAttribute, "");
        attach(element);
      }
    };
    const attachWithin = (root) => {
      if (root.matches(selector)) {
        attachOnce(root);
      }
      for (const element of root.querySelectorAll(selector)) {
        attachOnce(element);
      }
    };
    attachWithin(document.documentElement);
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node instanceof Element) {
            attachWithin(node);
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // src/marker-fixes/stampedRatingBarFix.ts
  // Stamped's review summary renders role-less divs with aria-label ("5-Star Ratings"),
  // which fails WCAG 4.1.2 (aria-label is prohibited on generic divs). role="img" makes
  // the label valid, and the visible percentage is folded into the label because role="img"
  // hides the subtree text from assistive technology.
  function attachStampedRatingBarRole(bar) {
    const label = bar.getAttribute("aria-label");
    if (!label) {
      return;
    }
    const pct = bar.querySelector(".summary-rating-bar-content")?.textContent?.replace(/ /g, " ").trim();
    bar.setAttribute("role", "img");
    if (pct && !label.includes(pct)) {
      bar.setAttribute("aria-label", `${label}: ${pct}`);
    }
  }
  const stampedRatingBarFix = {
    id: "stamped-rating-bars",
    start: () =>
      watchMarkedElements(
        "div.summary-rating-bar[aria-label]:not([role])",
        "data-patrol-stamped-rating-managed",
        attachStampedRatingBarRole
      ),
  };

  function attachStampedDisabledLink(link) {
    link.setAttribute("tabindex", "0");
  }
  const stampedDisabledLinkFix = {
    id: "stamped-disabled-links",
    start: () =>
      watchMarkedElements(
        "a.stamped-link-disabled:not([href]):not([tabindex])",
        "data-patrol-stamped-disabled-managed",
        attachStampedDisabledLink
      ),
  };

  // <stdin>
  stampedRatingBarFix.start();
  stampedDisabledLinkFix.start();
})();
/* @end-patrol-fixer:stamped-rating-bars */
/* @patrol-fixer:beam-heading-level */
(() => {
  // Beam's product-details widget renders <h3>Choose Your Impact</h3> inside its open shadow root, directly under the page's <h1> (WCAG 1.3.1 heading skip).
  // The same shadow root holds a focusable <sl-tooltip tabindex="0"> disclosure trigger with no role or name (WCAG 4.1.2),
  // and a root wrapper div carrying aria-label="product detail page Beam component" with no role (WCAG 4.1.2 — aria-label is prohibited on generic divs).
  const BEAM_HOST = "beam-product-details-page";
  const MANAGED_ATTRIBUTE = "data-patrol-beam-heading-managed";
  const TOOLTIP_MANAGED_ATTRIBUTE = "data-patrol-beam-tooltip-managed";
  const ROOT_MANAGED_ATTRIBUTE = "data-patrol-beam-root-managed";

  function fixHeadings(shadowRoot) {
    for (const heading of shadowRoot.querySelectorAll("h3.title")) {
      if (!heading.hasAttribute(MANAGED_ATTRIBUTE)) {
        heading.setAttribute(MANAGED_ATTRIBUTE, "");
        heading.setAttribute("role", "heading");
        heading.setAttribute("aria-level", "2");
      }
    }
  }

  function fixDisclosureTooltips(shadowRoot) {
    for (const tooltip of shadowRoot.querySelectorAll("sl-tooltip[tabindex]:not([role])")) {
      if (!tooltip.hasAttribute(TOOLTIP_MANAGED_ATTRIBUTE)) {
        tooltip.setAttribute(TOOLTIP_MANAGED_ATTRIBUTE, "");
        tooltip.setAttribute("role", "group");
        if (!tooltip.hasAttribute("aria-label")) {
          tooltip.setAttribute("aria-label", "Donation disclosure");
        }
      }
    }
  }

  function fixLabeledRootDivs(shadowRoot) {
    for (const root of shadowRoot.querySelectorAll("div[aria-label]:not([role])")) {
      if (!root.hasAttribute(ROOT_MANAGED_ATTRIBUTE)) {
        root.setAttribute(ROOT_MANAGED_ATTRIBUTE, "");
        root.setAttribute("role", "group");
      }
    }
  }

  function fixShadowContent(shadowRoot) {
    fixHeadings(shadowRoot);
    fixDisclosureTooltips(shadowRoot);
    fixLabeledRootDivs(shadowRoot);
  }

  function attachShadowHeadingFix(host) {
    const attach = () => {
      const shadowRoot = host.shadowRoot;
      if (!shadowRoot) {
        return false;
      }
      fixShadowContent(shadowRoot);
      const observer = new MutationObserver(() => fixShadowContent(shadowRoot));
      observer.observe(shadowRoot, { childList: true, subtree: true });
      return true;
    };
    if (attach()) {
      return;
    }
    customElements.whenDefined(BEAM_HOST).then(() => {
      if (!attach()) {
        setTimeout(attach, 1000);
      }
    });
  }

  function watchBeamHosts() {
    const attachOnce = (element) => {
      if (element instanceof HTMLElement && !element.hasAttribute("data-patrol-beam-managed")) {
        element.setAttribute("data-patrol-beam-managed", "");
        attachShadowHeadingFix(element);
      }
    };
    const attachWithin = (root) => {
      if (root.matches(BEAM_HOST)) {
        attachOnce(root);
      }
      for (const element of root.querySelectorAll(BEAM_HOST)) {
        attachOnce(element);
      }
    };
    attachWithin(document.documentElement);
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node instanceof Element) {
            attachWithin(node);
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // <stdin>
  watchBeamHosts();
})();
/* @end-patrol-fixer:beam-heading-level */
/* @patrol-fixer:klaviyo-heading-level */
(() => {
  function watchMarkedElements(selector, managedAttribute, attach) {
    const attachOnce = (element) => {
      if (element instanceof HTMLElement && !element.hasAttribute(managedAttribute)) {
        element.setAttribute(managedAttribute, "");
        attach(element);
      }
    };
    const attachWithin = (root) => {
      if (root.matches(selector)) {
        attachOnce(root);
      }
      for (const element of root.querySelectorAll(selector)) {
        attachOnce(element);
      }
    };
    attachWithin(document.documentElement);
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node instanceof Element) {
            attachWithin(node);
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Klaviyo's embedded signup form renders its "Sign Up & Take 20% Off" text as an <h1>,creating a duplicate h1 and a heading skip on every page that embeds the form (WCAG 1.3.1).
  function demoteKlaviyoHeading(heading) {
    heading.setAttribute("role", "heading");
    heading.setAttribute("aria-level", "2");
  }
  const klaviyoHeadingLevelFix = {
    id: "klaviyo-heading-level",
    start: () =>
      watchMarkedElements(
        'form[class*="klaviyo-form"] h1:not([role])',
        "data-patrol-klaviyo-heading-managed",
        demoteKlaviyoHeading
      ),
  };

  // <stdin>
  klaviyoHeadingLevelFix.start();
})();
/* @end-patrol-fixer:klaviyo-heading-level */
/* @patrol-fixer:digioh-close-button */
(() => {
  function watchMarkedElements(selector, managedAttribute, attach) {
    const attachOnce = (element) => {
      if (element instanceof HTMLElement && !element.hasAttribute(managedAttribute)) {
        element.setAttribute(managedAttribute, "");
        attach(element);
      }
    };
    const attachWithin = (root) => {
      if (root.matches(selector)) {
        attachOnce(root);
      }
      for (const element of root.querySelectorAll(selector)) {
        attachOnce(element);
      }
    };
    attachWithin(document.documentElement);
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node instanceof Element) {
            attachWithin(node);
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Digioh (lightboxcdn.com) renders its sidebar widget's close control as a bare div with aria-label="Close Modal" — no role (WCAG 4.1.2) and no keyboard access (WCAG 2.1.1).
  function makeCloseOperable(close) {
    close.setAttribute("role", "button");
    if (!close.hasAttribute("tabindex")) {
      close.setAttribute("tabindex", "0");
    }
    close.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        close.click();
      }
    });
  }
  const digiohCloseButtonFix = {
    id: "digioh-close-button",
    start: () =>
      watchMarkedElements("div.sidebar-iframe-close:not([role])", "data-patrol-digioh-close-managed", makeCloseOperable),
  };

  // Digioh modal popups (wrapper div#lightbox-<uuid> + campaign iframe + separate overlay element) open with no dialog semantics and no focus containment, and the iframe's tabindex="1" hijacks the page tab order — Tab escapes into the page behind the modal (WCAG 2.4.3)
  function isElementVisible(element) {
    return element.getClientRects().length > 0 && getComputedStyle(element).visibility !== "hidden";
  }
  function attachLightboxModalTrap(wrapper) {
    let close = null;
    let iframe = null;
    let active = false;
    let triggerElement = null;
    let sentinel = null;

    const resolveParts = () => {
      close = wrapper.querySelector("div.sidebar-iframe-close");
      iframe = wrapper.querySelector("iframe");
      const overlay = document.getElementById(`sidebar-overlay-${wrapper.id}`);
      return !!(close && iframe && overlay);
    };

    const handleFocusIn = (event) => {
      if (!wrapper.contains(event.target)) {
        close.focus();
      }
    };
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        close.click();
        return;
      }
      if (event.key !== "Tab") {
        return;
      }
      const activeElement = document.activeElement;
      if (activeElement === close) {
        event.preventDefault();
        iframe.focus();
      } else if (!wrapper.contains(activeElement)) {
        event.preventDefault();
        close.focus();
      }
    };
    const engage = () => {
      if (active) return;
      active = true;
      wrapper.setAttribute("role", "dialog");
      wrapper.setAttribute("aria-modal", "true");
      if (!wrapper.hasAttribute("aria-label")) {
        wrapper.setAttribute("aria-label", iframe.getAttribute("title") || "Promotional dialog");
      }
      iframe.setAttribute("tabindex", "0");
      if (!sentinel) {
        sentinel = document.createElement("button");
        sentinel.type = "button";
        sentinel.setAttribute("data-patrol-trap-sentinel", "");
        sentinel.setAttribute("aria-label", "Close dialog");
        sentinel.style.cssText =
          "position:fixed;width:1px;height:1px;opacity:0;pointer-events:none;border:0;padding:0;background:transparent;";
        sentinel.addEventListener("focus", () => {
          close.focus();
        });
        sentinel.addEventListener("click", () => {
          close.click();
        });
      }
      if (sentinel.parentNode !== wrapper) {
        wrapper.appendChild(sentinel);
      }
      const current = document.activeElement;
      triggerElement = current instanceof HTMLElement && !wrapper.contains(current) ? current : null;
      document.addEventListener("focusin", handleFocusIn, true);
      document.addEventListener("keydown", handleKeyDown, true);
      iframe.focus();
    };
    const disengage = () => {
      if (!active) return;
      active = false;
      if (sentinel && sentinel.parentNode) {
        sentinel.parentNode.removeChild(sentinel);
      }
      document.removeEventListener("focusin", handleFocusIn, true);
      document.removeEventListener("keydown", handleKeyDown, true);
      if (triggerElement && triggerElement.isConnected) {
        triggerElement.focus();
      }
      triggerElement = null;
    };
    const check = () => {
      if (wrapper.isConnected && resolveParts() && isElementVisible(wrapper)) {
        engage();
        if (sentinel && wrapper.lastElementChild !== sentinel) {
          wrapper.appendChild(sentinel);
        }
      } else {
        disengage();
      }
    };
    check();
    const wrapperObserver = new MutationObserver(check);
    wrapperObserver.observe(wrapper, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style", "hidden"],
    });
    const bodyObserver = new MutationObserver(check);
    bodyObserver.observe(document.body, { childList: true });
  }
  const digiohModalTrapFix = {
    id: "digioh-modal-trap",
    start: () => watchMarkedElements('div[id^="lightbox-"]', "data-patrol-digioh-modal-managed", attachLightboxModalTrap),
  };

  // <stdin>
  digiohCloseButtonFix.start();
  digiohModalTrapFix.start();
})();
/* @end-patrol-fixer:digioh-close-button */
/* @patrol-fixer:corso-button-keys */
(() => {
  function watchMarkedElements(selector, managedAttribute, attach) {
    const attachOnce = (element) => {
      if (element instanceof HTMLElement && !element.hasAttribute(managedAttribute)) {
        element.setAttribute(managedAttribute, "");
        attach(element);
      }
    };
    const attachWithin = (root) => {
      if (root.matches(selector)) {
        attachOnce(root);
      }
      for (const element of root.querySelectorAll(selector)) {
        attachOnce(element);
      }
    };
    attachWithin(document.documentElement);
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node instanceof Element) {
            attachWithin(node);
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Corso (shipping protection) replaces the cart checkout button with a
  // <div role="button" tabindex="0"> that only listens for clicks. Forward
  // Enter/Space so it is actually keyboard-operable (WCAG 2.1.1).
  function attachCorsoButtonKeys(button) {
    button.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        button.click();
      }
    });
  }
  const corsoButtonKeysFix = {
    id: "corso-button-keys",
    start: () => watchMarkedElements('.corso-button[role="button"]', "data-patrol-corso-keys-managed", attachCorsoButtonKeys),
  };

  // <stdin>
  corsoButtonKeysFix.start();
})();
/* @end-patrol-fixer:corso-button-keys */
